import Vue from 'vue'
import GoogleLogin from 'vue-google-login'

Vue.component('GoogleLogin', GoogleLogin)
